import { render, staticRenderFns } from "./studentHomePage.vue?vue&type=template&id=97d4a9c2&scoped=true"
import script from "./studentHomePage.vue?vue&type=script&lang=js"
export * from "./studentHomePage.vue?vue&type=script&lang=js"
import style0 from "./studentHomePage.vue?vue&type=style&index=0&id=97d4a9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d4a9c2",
  null
  
)

export default component.exports